// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --main-text-color: #344054;
  --second-text-color: #667085;
  --third-text-color: #475467;
  --main-purple: #7f56d9;
  --light-gray: #eaecf0;
  --light-border-color: #d0d5dd;
  --border-error-solid: #d92d20;
}
`, "",{"version":3,"sources":["webpack://./src/components/SettingsPage/variables.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;EAC7B,6BAA6B;AAC/B","sourcesContent":[":root {\n  --main-text-color: #344054;\n  --second-text-color: #667085;\n  --third-text-color: #475467;\n  --main-purple: #7f56d9;\n  --light-gray: #eaecf0;\n  --light-border-color: #d0d5dd;\n  --border-error-solid: #d92d20;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
